import { render } from "./Cell.vue?vue&type=template&id=1138cbe0&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"

import "./Cell.vue?vue&type=style&index=0&id=1138cbe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1138cbe0"]])

export default __exports__